import { useEffect } from 'react';
import { Config } from '@/config/environment';
import { sfAuth } from '@/auth/SFAuth';
import { emitSessionExpired } from '@/auth/sessionEvents';
import useInterval from '@/hooks/useInterval';

const POLL_INTERVAL_MS = (Config.tokenDuration * 1000) / 10;

const checkSession = async () => {
  // If no tokens exist at all, the user simply isn't logged in — skip the check
  if (!sfAuth.hasSession()) return;

  const token = await sfAuth.checkSession();
  if (!token) {
    emitSessionExpired('Your session has expired. Please sign in again.');
  }
};

export const SessionMonitor = () => {
  // Initial session check on mount
  useEffect(() => {
    checkSession();
  }, []);

  // Poll session on interval
  useInterval(() => {
    checkSession();
  }, POLL_INTERVAL_MS);

  // Check session when coming back online
  useEffect(() => {
    const handleOnline = () => {
      checkSession();
    };

    window.addEventListener('online', handleOnline);
    return () => window.removeEventListener('online', handleOnline);
  }, []);

  return null;
};
